import React, { useState } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { LiliDropDownItemTemplate } from './LiliDropDownItemTemplate';
import { LiliDropDownValueTemplate } from './LiliDropDownValueTemplate';
import { ReactComponent as DownArrowIcon } from '../Icons/shared/ic-shared-down-arrow.svg';
import './LiliDropdown.css';

// See https://primereact.org/dropdown/ and add any additional props that you need
export interface LiliDropdownItem {
  title: string;
  value: any;
}

export interface LiliDropdownProps {
  items: LiliDropdownItem[];
  title: string;
  selectedDropDownItem?: LiliDropdownItem;
  onSelect: (item: LiliDropdownItem) => void;
  onClear?: () => void;
  className?: string;
  showClose?: boolean;
  id?: string;
}

export const LiliDropdown = (props: LiliDropdownProps) => {
  const { items, title, selectedDropDownItem, onSelect, onClear, showClose, className, id } = props;

  const [isOptionPresented, setIsOptionPresented] = useState<boolean>(false);

  return (
    <div className={`card flex justify-content-center  ${className}`}>
      <Dropdown
        value={selectedDropDownItem?.value}
        id={id ?? title}
        onChange={(e) => {
          const newItem = items.find((item) => item.value === e.value);
          if (newItem) onSelect(newItem);
        }}
        options={items}
        optionLabel='optionLabel'
        className={`!z-99999  dropdown outline-none shadow-none p-0 flex flex-row justify-between min-h-[44px]  items-center px-[12px] rounded-md hover:bg-bw11 w-full border-[1px]  ${isOptionPresented ? 'border-action03 ' : selectedDropDownItem ? 'border-bw06' : 'border-bw03'}`}
        panelClassName={`!z-99999 shadow-lg bg-bw00 rounded-md overflow-scroll ${isOptionPresented ? 'max-h-[200px]' : 'max-h-[0px]'}`}
        placeholder={title}
        valueTemplate={() => (
          <LiliDropDownValueTemplate
            selectedValue={selectedDropDownItem?.value}
            selectedTitle={selectedDropDownItem?.title || ''}
            title={title}
            showClose={showClose}
            onClear={() => {
              if (onClear) {
                onClear();
              }
              setIsOptionPresented(false);
            }}
          />
        )}
        itemTemplate={(item) => (
          <LiliDropDownItemTemplate item={item} isSelected={selectedDropDownItem?.value === item.value || false} />
        )}
        dropdownIcon={
          <DownArrowIcon
            className={`text-bw07 mr-[6px] h-[6px] transition-all ${isOptionPresented ? 'rotate-180' : 'rotate-0'}`}
          />
        }
        onFocus={() => setIsOptionPresented(true)}
        onHide={() => setIsOptionPresented(false)}
        unstyled
      />
    </div>
  );
};
